import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/layout/Header";
import AdminSidebar from "../../components/layout/AdminSidebar";

const SuperAdminPage = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  return (
    // 1. O 'flex' aqui salva a vida. Ele força a Sidebar (quando static no Desktop) a ficar lado a lado com o conteúdo, matando o buraco.
    <div className="flex min-h-screen bg-slate-50 font-sans text-slate-800">
      
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        onToggleSidebar={toggleSidebar}
      />

      {/* 2. O flex-1 garante que o lado direito ocupe todo o resto da tela sem esmagar. */}
      <div className="flex-1 flex flex-col min-w-0">
        
        <Header isSidebarOpen={isSidebarOpen} onToggleSidebar={toggleSidebar} />

        {/* 3. A CURA DA MORDIDA: style={{ paddingTop: '72px' }} injetado direto no DOM. 
            Sem depender do Tailwind compilar colchetes. O Header nunca mais vai engolir o título. */}
        <main className="flex-1 w-full" style={{ paddingTop: '72px' }}>
          <div className="p-4 sm:p-6 lg:p-8">
            <Outlet />
          </div>
        </main>

      </div>
    </div>
  );
};

export default SuperAdminPage;